// Gallery Page
export default function Gallery() { return <div><h1 className="text-4xl font-bold text-center py-20">Gallery</h1><p className="text-center">Photos from our classes, competitions and events.</p></div>; }